/* cv-collection.js | Conveyor Apparel | REDESIGN_SPEC 4.4 (CL-3, CL-6, CL-7, CL-8, wave 3)
   Deferred, no libraries. Loaded by the collection and search sections (once per page, guarded). Uses window.cvSheet and window.cvTrack
   from cv-core.js when they exist and never depends on them to render anything: every shelf state is a real URL that works without script.

   1. Load more (CL-8). The "Show 24 more" link is a real <a href="?page=2">. A click appends the next page's cards (a section fetch of the
      grid section, so only that section's HTML comes back), keeps the page count in history.state via replaceState (and, inside try/catch,
      in sessionStorage), and moves focus to the first new card. BACK REPLAY: when a page is loaded fresh (history navigation or reload)
      and the stored count is above the one page the HTML holds, pages 2 to N are fetched in parallel, appended in order, and the scroll
      position (or the card that was clicked) is restored. A bfcache restore never runs this file again, so nothing happens there. No
      unload handler, no storage requirement: if everything fails the shopper simply lands at the top with the button intact.
   2. Filter sheet and desktop rail (CL-6). One panel markup, two modes. Sheet = STAGED: radios (garment, sort) and swatch checkboxes
      (colour, only when the section setting is on) change nothing until "Show N designs"; N is read from a light fetch of the count source
      in snippets/cv-garment-bar (never the grid), "Clear all" resets the staged choices. Rail = every change goes straight to its URL.
      Theme links keep the staged garment and sort (on search they carry neither a count nor a sort_by, see snippets/cv-shelf-themes).
      On search the button counts "results", on a shelf "designs". The URL form (legacy tag URL on collections, filter.p.tag on search) is written in
      buildUrl(), the twin of snippets/cv-shelf-url.liquid: change both together if gate G8 picks another form.
   3. Floating pill. Shown on phones once the inline controls have scrolled out of view.
   4. Tee tag (CL-3). Adds the offer=3 sentence from the URL and keeps "n of 3 in your bag" true after Back (bfcache) by reading /cart.js.
      The tee rule is the single one of snippets/cv-tee-count.liquid ("Oversized Tee" in the product title), same twin as cv-pdp.js.
   Events (trackCustom only, through cvTrack): filter_open, filter_apply, garment_pick, load_more. */
(function () {
  'use strict';
  if (window.__cvCollection) return;
  window.__cvCollection = true;

  var doc = document;
  var root = doc.documentElement;

  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function track(name, params) {
    try { if (typeof window.cvTrack === 'function') window.cvTrack(name, params || {}); } catch (e) {}
  }
  function navType() {
    try {
      var n = window.performance && window.performance.getEntriesByType && window.performance.getEntriesByType('navigation')[0];
      return n ? n.type : 'navigate';
    } catch (e) { return 'navigate'; }
  }
  function sget(k) { try { return JSON.parse(window.sessionStorage.getItem(k)); } catch (e) { return null; } }
  function sset(k, v) { try { window.sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function jump(y) {
    // html has scroll-behavior: smooth (cv-core.css); a restore must be instant
    var prev = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(0, y);
    root.style.scrollBehavior = prev;
  }

  /* ======================================================================= 1. Load more and Back replay */
  var shelf = null;
  var grid = null;
  var more = null;

  function initMore() {
    shelf = $('[data-cv-shelf]');
    grid = $('[data-cv-grid]');
    more = $('[data-cv-more]');
    if (!shelf || !grid) return;

    var sid = shelf.getAttribute('data-cv-section');
    var pattern = shelf.getAttribute('data-cv-pattern') || '';
    var per = parseInt(shelf.getAttribute('data-cv-per'), 10) || 24;
    var pages = parseInt(shelf.getAttribute('data-cv-pages'), 10) || 1;
    var items = parseInt(shelf.getAttribute('data-cv-items'), 10) || 0;
    var first = parseInt(shelf.getAttribute('data-cv-page'), 10) || 1;
    var last = first;
    var busy = false;
    var key = 'cvlm:' + window.location.pathname + window.location.search;
    var btn = more ? $('[data-cv-more-btn]', more) : null;
    var status = more ? $('[data-cv-more-status]', more) : null;
    var noun = status ? (status.getAttribute('data-cv-noun') || 'designs') : 'designs';

    function pageUrl(n, section) {
      if (!pattern) return '';
      var u = pattern.replace('__N__', String(n));
      if (section) u += (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
      return u;
    }

    function cardsOf(html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      return $$('[data-cv-grid] > li', d);
    }

    function fetchPage(n) {
      return window.fetch(pageUrl(n, true), { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('page ' + n);
        return r.text();
      }).then(cardsOf);
    }

    function append(list) {
      var firstNew = null;
      list.forEach(function (li) {
        var node = doc.importNode(li, true);
        if (!firstNew) firstNew = node;
        grid.appendChild(node);
      });
      return firstNew;
    }

    function paint() {
      if (!more) return;
      var shownTo = Math.min(last * per, items);
      var left = items - shownTo;
      if (status) {
        if (left <= 0) status.textContent = (first > 1 ? noun.charAt(0).toUpperCase() + noun.slice(1) + ' ' + ((first - 1) * per + 1) + ' to ' + shownTo + ' of ' + items : 'Showing all ' + items);
        else if (first > 1) status.textContent = noun.charAt(0).toUpperCase() + noun.slice(1) + ' ' + ((first - 1) * per + 1) + ' to ' + shownTo + ' of ' + items;
        else status.textContent = 'Showing ' + shownTo + ' of ' + items;
      }
      var note = $('[data-cv-note]');
      if (note && last >= pages) note.removeAttribute('hidden');
      if (btn) {
        if (last >= pages) {
          if (btn.parentNode) btn.parentNode.removeChild(btn);
          btn = null;
        } else {
          btn.setAttribute('href', pageUrl(last + 1, false));
          btn.textContent = 'Show ' + Math.min(per, left) + ' more';
        }
      }
    }

    function save(extra) {
      var s = {};
      try {
        var cur = window.history.state;
        if (cur && typeof cur === 'object') for (var k in cur) s[k] = cur[k];
      } catch (e) {}
      s.cvPages = last;
      if (extra) for (var j in extra) s[j] = extra[j];
      try { window.history.replaceState(s, '', window.location.href); } catch (e) {}
      sset(key, { n: last, card: s.cvCard || null, y: typeof s.cvY === 'number' ? s.cvY : null });
    }

    if (btn) {
      doc.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-cv-more-btn]') : null;
        if (!b || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
        e.preventDefault();
        if (busy || last >= pages) return;
        busy = true;
        more.classList.add('is-busy');
        b.setAttribute('aria-busy', 'true');
        fetchPage(last + 1).then(function (list) {
          var firstNew = append(list);
          last += 1;
          paint();
          save();
          track('load_more', { page: last });
          if (firstNew) {
            var a = $('a[href]:not([tabindex="-1"])', firstNew);
            if (a) { try { a.focus({ preventScroll: true }); } catch (err) {} }
          }
        }).catch(function () {
          window.location.href = b.getAttribute('href');
        }).then(function () {
          busy = false;
          if (more) more.classList.remove('is-busy');
          if (b) b.removeAttribute('aria-busy');
        });
      });
    }

    // remember where the shopper went, so Back can bring them to the same card
    doc.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('.cv-card a[href]') : null;
      if (!a) return;
      var card = a.closest('.cv-card');
      save({ cvCard: card ? card.getAttribute('data-cv-handle') : null, cvY: window.pageYOffset });
    });

    // Back replay: only on a fresh load of a history entry (a bfcache restore does not run this file again)
    var nt = navType();
    if (nt === 'back_forward' || nt === 'reload') {
      var st = null;
      try { st = window.history.state && typeof window.history.state === 'object' ? window.history.state : null; } catch (e) {}
      var want = st && typeof st.cvPages === 'number' ? st.cvPages : 0;
      var ss = sget(key);
      var y = st && typeof st.cvY === 'number' ? st.cvY : (ss && typeof ss.y === 'number' ? ss.y : null);
      var cardH = st && st.cvCard ? st.cvCard : (ss && ss.card ? ss.card : null);
      if (!want && ss && typeof ss.n === 'number') want = ss.n;
      want = Math.min(want, pages);
      var domPages = Math.ceil($$('.cvc-grid__i', grid).length / per) || 1;
      if (want > last && domPages <= 1 && pattern) {
        try { window.history.scrollRestoration = 'manual'; } catch (e) {}
        if (more) more.classList.add('is-busy');
        var jobs = [];
        for (var n = last + 1; n <= want; n++) jobs.push(fetchPage(n));
        Promise.all(jobs).then(function (lists) {
          lists.forEach(function (l) { append(l); });
          last = want;
          paint();
          save();
          if (typeof y === 'number') {
            jump(y);
          } else if (cardH) {
            var c = grid.querySelector('.cv-card[data-cv-handle="' + cardH.replace(/"/g, '') + '"]');
            if (c) c.scrollIntoView({ block: 'center' });
          }
        }).catch(function () {
          /* the shopper stays at the top with the button intact */
        }).then(function () {
          if (more) more.classList.remove('is-busy');
          try { window.history.scrollRestoration = 'auto'; } catch (e) {}
        });
      }
    }
  }

  /* ======================================================================= 2. Filter sheet and rail */
  var sheetEl = null;
  var countSeq = 0;
  var countCache = {};

  function go(url) {
    var st = null;
    try { st = window.history.state; } catch (e) {}
    // the sheet pushed one history entry: replace it, so Back returns to the shelf the shopper left
    if (st && st.cvSheet === 'cv-filter-sheet') window.location.replace(url);
    else window.location.assign(url);
  }

  function readState(panel) {
    var st = { garment: panel.getAttribute('data-cv-garment') || 'All', sort: panel.getAttribute('data-cv-sort') || '', colours: [] };
    var g = $('input[data-cv-f="garment"]:checked', panel);
    if (g) st.garment = g.value;
    var s = $('input[data-cv-f="sort"]:checked', panel);
    if (s) st.sort = s.value;
    $$('input[data-cv-f="colour"]:checked', panel).forEach(function (c) { st.colours.push({ name: c.name, value: c.value }); });
    return st;
  }

  // Twin of snippets/cv-shelf-url.liquid. opts.kind overrides the panel kind (theme links are always collections);
  // opts.bare drops colour and the other filters (a theme change keeps only garment and sort).
  function buildUrl(panel, st, base, opts) {
    opts = opts || {};
    var kind = opts.kind || panel.getAttribute('data-cv-kind') || 'collection';
    var p = new URLSearchParams();
    var extra = new URLSearchParams((panel.getAttribute('data-cv-extra') || '').replace(/^&/, ''));
    var cp = panel.getAttribute('data-cv-colour-param');
    var def = panel.getAttribute('data-cv-sort-default') || '';
    var sort = st.sort && st.sort !== def ? st.sort : '';
    var g = st.garment && st.garment !== 'All' ? st.garment.toLowerCase() : '';
    var url;
    if (kind === 'search') {
      p.set('q', panel.getAttribute('data-cv-terms') || '');
      p.set('options[prefix]', 'last');
      if (g) p.set('filter.p.tag', 'style-' + g);
      if (sort) p.set('sort_by', sort);
      if (!opts.bare) {
        if (cp) extra.delete(cp);
        extra.forEach(function (v, k) { p.append(k, v); });
        st.colours.forEach(function (c) { p.append(c.name, c.value); });
      }
      url = (base || panel.getAttribute('data-cv-base')) + '?' + p.toString();
    } else {
      url = (base || panel.getAttribute('data-cv-base')) + (g ? '/style-' + g : '');
      if (sort) p.set('sort_by', sort);
      if (!opts.bare) {
        if (cp) extra.delete(cp);
        extra.forEach(function (v, k) { p.append(k, v); });
        st.colours.forEach(function (c) { p.append(c.name, c.value); });
      }
      var q = p.toString();
      if (q) url += '?' + q;
    }
    return url;
  }

  function countSourceSection() {
    var src = $('[data-cv-count-src]');
    var sec = src && src.closest ? src.closest('[id^="shopify-section-"]') : null;
    return sec ? sec.id.replace('shopify-section-', '') : '';
  }

  // The sheet button counts "designs" on a shelf and "results" on search (the panel carries data-cv-noun, set in snippets/facets):
  // search.results_count also counts the pages and articles that match, so it is not a count of designs.
  function paintApply(panel, n) {
    var b = $('[data-cv-apply]', sheetEl);
    if (!b) return;
    var noun = panel && panel.getAttribute('data-cv-noun') === 'result' ? 'result' : 'design';
    if (typeof n !== 'number' || isNaN(n)) {
      b.textContent = 'Show ' + noun + 's';
      b.removeAttribute('aria-disabled');
      return;
    }
    if (n === 0) {
      b.textContent = 'No ' + noun + 's match';
      b.setAttribute('aria-disabled', 'true');
    } else {
      b.textContent = 'Show ' + n + ' ' + noun + (n === 1 ? '' : 's');
      b.removeAttribute('aria-disabled');
    }
  }

  function updateCount(panel) {
    var sid = countSourceSection();
    var url = buildUrl(panel, readState(panel));
    if (!sid) { paintApply(panel, NaN); return; }
    var req = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid);
    if (typeof countCache[req] === 'number') { paintApply(panel, countCache[req]); return; }
    var seq = ++countSeq;
    window.fetch(req, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('count');
      return r.text();
    }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var el = $('[data-cv-count-src]', d);
      var n = el ? parseInt(el.getAttribute('data-cv-count'), 10) : NaN;
      if (isNaN(n)) throw new Error('count');
      countCache[req] = n;
      if (seq === countSeq) paintApply(panel, n);
    }).catch(function () {
      if (seq === countSeq) paintApply(panel, NaN);
    });
  }

  function refreshThemeLinks(panel) {
    var st = readState(panel);
    $$('[data-cv-theme-base]', panel).forEach(function (a) {
      a.setAttribute('href', buildUrl(panel, st, a.getAttribute('data-cv-theme-base'), { kind: 'collection', bare: true }));
      var c = $('.cvc-th__c', a);
      if (c) {
        // a theme's count is its total; it is only true when every design counts (All, Tee)
        if (st.garment === 'All' || st.garment === 'Tee') c.removeAttribute('hidden'); else c.setAttribute('hidden', '');
      }
    });
  }

  function resetStaged(panel) {
    $$('input[data-cv-f]', panel).forEach(function (i) { i.checked = i.defaultChecked; });
    refreshThemeLinks(panel);
  }

  function initPanels() {
    sheetEl = $('#cv-filter-sheet');
    $$('[data-cv-panel]').forEach(function (panel) {
      var mode = panel.getAttribute('data-cv-panel');
      if (mode === 'rail') {
        panel.addEventListener('change', function (e) {
          if (!e.target.matches || !e.target.matches('input[data-cv-f]')) return;
          track('filter_apply', { mode: 'rail', garment: readState(panel).garment });
          go(buildUrl(panel, readState(panel)));
        });
        return;
      }
      // sheet: staged
      panel.addEventListener('change', function (e) {
        if (!e.target.matches || !e.target.matches('input[data-cv-f]')) return;
        refreshThemeLinks(panel);
        updateCount(panel);
      });
      panel.addEventListener('click', function (e) {
        var a = e.target.closest ? e.target.closest('[data-cv-theme-base]') : null;
        if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
        e.preventDefault();
        track('filter_apply', { mode: 'sheet', theme: a.getAttribute('data-cv-theme-base') });
        go(a.getAttribute('href'));
      });
      if (sheetEl) {
        var apply = $('[data-cv-apply]', sheetEl);
        var clear = $('[data-cv-clear]', sheetEl);
        if (apply) {
          apply.addEventListener('click', function () {
            if (apply.getAttribute('aria-disabled') === 'true') return;
            var st = readState(panel);
            track('filter_apply', { mode: 'sheet', garment: st.garment, sort: st.sort, colours: st.colours.length });
            go(buildUrl(panel, st));
          });
        }
        if (clear) {
          clear.addEventListener('click', function () {
            var g = $('input[data-cv-f="garment"][value="All"]', panel);
            if (g) g.checked = true;
            var def = panel.getAttribute('data-cv-sort-default') || '';
            var sorts = $$('input[data-cv-f="sort"]', panel);
            var pick = null;
            sorts.forEach(function (s) { if (s.value === def) pick = s; });
            if (!pick && sorts.length) pick = sorts[0];
            if (pick) pick.checked = true;
            $$('input[data-cv-f="colour"]', panel).forEach(function (c) { c.checked = false; });
            refreshThemeLinks(panel);
            updateCount(panel);
          });
        }
        sheetEl.addEventListener('cv:sheet-open', function () {
          resetStaged(panel);
          updateCount(panel);
          track('filter_open');
        });
      }
      refreshThemeLinks(panel);
    });
  }

  /* ======================================================================= 3. Floating pill */
  function initPill() {
    var pill = $('[data-cv-pill]');
    if (!pill) return;
    var btn = $('button', pill);
    var target = $('[data-cv-seg]') || $('.cvc-hd__row') || $('.cvc-hd');
    if (!target) return;
    var on = false;
    function set(v) {
      if (v === on) return;
      on = v;
      pill.classList.toggle('is-on', v);
      if (btn) btn.setAttribute('tabindex', v ? '0' : '-1');
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        // shown only once the inline controls are ABOVE the viewport (scrolled past), never before they are reached
        set(!e.isIntersecting && e.boundingClientRect.bottom < 0);
      }, { threshold: 0 }).observe(target);
    } else {
      var tick = false;
      window.addEventListener('scroll', function () {
        if (tick) return;
        tick = true;
        window.requestAnimationFrame(function () {
          tick = false;
          set(target.getBoundingClientRect().bottom < 0);
        });
      }, { passive: true });
    }
  }

  /* ======================================================================= 4. Tee tag */
  function teeUnits(cart) {
    var n = 0;
    (cart && cart.items || []).forEach(function (it) {
      if (String(it.product_title || '').indexOf('Oversized Tee') > -1) n += it.quantity;
    });
    return n;
  }

  function initTee() {
    var tag = $('[data-cv-tee]');
    if (!tag) return;
    var t = $('[data-cv-tee-t]', tag);
    var s = $('[data-cv-tee-s]', tag);
    var word = tag.getAttribute('data-cv-word') || '';
    var offer = false;
    try { offer = new URLSearchParams(window.location.search).get('offer') === '3'; } catch (e) {}
    function paint(n) {
      var line = 'Any 3 tees ₹2,398. Pick three.';
      var state = '';
      if (n >= 3) {
        line = n + ' tees in your bag.';
        state = word;
      } else if (n > 0) {
        line = n + ' of 3 in your bag.';
        state = word;
      } else if (offer) {
        line = 'Pick any 3 tees for ₹2,398. Add each one to your bag and the discount applies.';
        state = word;
      }
      if (t) t.textContent = line;
      if (s) { s.textContent = state; if (state) s.removeAttribute('hidden'); else s.setAttribute('hidden', ''); }
    }
    function refresh() {
      window.fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
        paint(teeUnits(c));
      }).catch(function () {});
    }
    paint(parseInt(tag.getAttribute('data-cv-tees'), 10) || 0);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  /* ======================================================================= boot */
  function boot() {
    initMore();
    initPanels();
    initPill();
    initTee();
    doc.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-cv-garment]') : null;
      if (a) track('garment_pick', { garment: a.getAttribute('data-cv-garment') });
    });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
